import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project import
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import ViewProfilePage from 'pages/extra-pages/viewprofiles';
import AccountSettingsPage from 'pages/extra-pages/AccountSettings';
import JoinBetaWaitlist from 'pages/extra-pages/joinbetawaitlist';

const HomeDashboardPage = Loadable(lazy(() => import('pages/DashboardPage')));
const PerformanceDashboardPage = Loadable(lazy(() => import('pages/PerformanceDashboard')));
const TradingChallengePage = Loadable(lazy(() => import('pages/trading-challenge')));
const TermsOfServicePage = Loadable(lazy(() => import('pages/terms-of-service')));
const PrivacyPolicyPage = Loadable(lazy(() => import('pages/privacy-policy')));
const AppTradingCycle = Loadable(lazy(() => import('pages/tradingcycle')));
const AppPreTradeCockpit = Loadable(lazy(() => import('pages/pretrade-cockpit')));

const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));
const AppJournal = Loadable(lazy(() => import('pages/journal')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { path: 'dashboard', element: <HomeDashboardPage /> },
        { path: 'statistics', element: <Navigate to="/performance" replace /> },
        { path: 'performance', element: <PerformanceDashboardPage /> },
        { path: 'performance-dashboard', element: <PerformanceDashboardPage /> },
        { path: 'trading-challenge', element: <TradingChallengePage /> },
        { path: 'tradingcycle', element: <AppTradingCycle /> },
        { path: 'pretrade-cockpit', element: <AppPreTradeCockpit /> },
        { path: 'journal', element: <AppJournal /> },
        { path: 'contact-us', element: <AppContactUS /> },
        { path: 'terms-of-service', element: <TermsOfServicePage /> },
        { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
        { path: 'edit-profile', element: <Navigate to="/view-profile" replace /> },
        { path: 'view-profile', element: <ViewProfilePage /> },
        { path: 'account-settings', element: <AccountSettingsPage /> }
      ]
    },
    {
      path: '/joinbetawaitlist',
      element: <JoinBetaWaitlist />
    },
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        { path: '404', element: <MaintenanceError /> },
        { path: '500', element: <MaintenanceError500 /> },
        { path: 'under-construction', element: <MaintenanceUnderConstruction /> },
        { path: 'coming-soon', element: <MaintenanceComingSoon /> }
      ]
    },
    {
      path: '*',
      element: <MaintenanceError />
    }
  ]
};

export default MainRoutes;
